<template>
  <cursor/>
  <router-view/>
</template>

<script>
import cursor from '@/components/cursor.vue'
export default {
  name: 'application',
  components: { cursor }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

:root {
  --large-txt-color: #ccd6f6;
  --afterlarge-txt-color: #8892b0;
  --afterdark: #737b94;
  --maincolor: #63FCD7;
  --secondcolor: #4cc6a7;
  --containerbackground: #112441b2;
}

html, body { margin: 0; padding: 0; cursor: none; }
.liner { background-image: url(@/assets/circles.svg); background-size: 110% auto; background-position: center; color: transparent; -webkit-background-clip: text; background-clip: text; }
.unselectable { -moz-user-select: -moz-none; -khtml-user-select: none; -webkit-user-select: none; -o-user-select: none; user-select: none; }
bold { color: #63FCD7; text-decoration: none; position: relative; font-weight: 600; text-shadow: 0 0 20px #63FCD7; }
bold:after { position: absolute; content: ''; height: 1.5px; bottom: -3px; left: 0; right: 0; width: 100%; background: #3fa78d; }

a:hover { cursor: none; }

@keyframes show_in_a {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
@keyframes show_out_a {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

@keyframes show_in {
    from {
        opacity: 0;
        transform: translateY(18px);
    }
    to {
        opacity: 1;
        transform: translateY(0px);
    }
}
.link {
  color: var(--maincolor);
  text-decoration: none;
  position: relative;
  transition: transform .1s ease-in-out;
}
.link::before, .link::after{
  content: "";
  position: absolute;
  background-color: var(--maincolor);
  transition: transform .5s;
}

.link::after{
  left: 0;
  width: 100%;
  height: 3px;
  border-radius: 10px;
  bottom: -10px;
  transform: scaleX(0);
  transform-origin: left;
}
.link:hover::after{
    transform: scaleX(1);
}

.badge {
  border-radius: 6px;
    box-shadow: 0px 5px 0px #296c5b,
                0px 10px 10px #8bffe225
    ;
    margin-top: 3px;
    margin-bottom: 3px;
    margin-left: 5px;
    margin-right: 5px;
}
</style>
